<p-toast position="top-right" role="status" aria-live="polite" aria-atomic="true"></p-toast>

<div class="supplier-detail-container p-6 w-full">
  <!-- Breadcrumb -->
  <div class="mb-4">
    <p-breadcrumb
      styleClass="custom-breadcrumb"
      [model]="breadcrumbItems()"
      [home]="{ icon: 'pi pi-home', routerLink: '/axa/suppliers-dashboard', ariaLabel: 'Home' }" [attr.aria-label]="'Breadcrumb navigation'"
    >
    </p-breadcrumb>
  </div>

  <!-- Page Header -->
  <div class="page-header mb-4">
    <div class="header-content">
      <div class="header-left">
        <button
          pButton
          icon="pi pi-arrow-left"
          class="p-button-text p-button-plain header-back-btn"
          (click)="goBack()"
          [attr.aria-label]="'Torna al registro fornitori'"
          title="Torna al registro fornitori"
        ></button>
        <div>
          <h1 id="page-heading" class="text-3xl font-bold m-0" style="color: #00125b">
            {{ supplier().supplierName || 'Dettaglio Fornitore' }}
          </h1>
          <p class="text-color-secondary mt-2 mb-0">
            Visualizza e modifica i dettagli del fornitore
          </p>
        </div>
      </div>
    </div>
  </div>

  @if (supplier() && supplier().details) {
    <!-- ================= SECTION 1: ANAGRAFICA ================= -->
    <section
      appCollapsibleSection
      sectionExpanded
      class="surface-0 border-round p-5 mb-4 shadow-1"
      role="region"
      aria-labelledby="anagrafica-heading"
    >
      <div
        class="flex flex-wrap align-items-center justify-content-between gap-2 mb-4 pb-3 border-bottom-1 border-200"
      >
        <div class="flex align-items-center gap-3">
          <i class="pi pi-user text-2xl" style="color: #00125b" aria-hidden="true"></i>
          <h2 id="anagrafica-heading" class="text-xl font-semibold m-0">Anagrafica Fornitore</h2>
        </div>
        <div class="flex align-items-center gap-2">
          @if (supplier().status) {
            <p-tag
              [value]="supplier().statusDisplay || supplier().status"
              [severity]="getStatusSeverity(supplier().status)"
              [attr.role]="'status'"
              [attr.aria-label]="
                'Stato fornitore: ' + (supplier().statusDisplay || supplier().status)
              "
            ></p-tag>
          }
          <app-section-collapse-toggle sectionName="Anagrafica Fornitore"></app-section-collapse-toggle>
        </div>
      </div>

      <div class="form-grid" [formGroup]="anagraficaForm">
        <div class="item">
          <label for="supplier-name"
            >Ragione Sociale <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <input
            id="supplier-name"
            pInputText
            formControlName="supplierName"
            aria-required="true"
            [attr.aria-invalid]="
              anagraficaForm.get('supplierName')?.invalid &&
              anagraficaForm.get('supplierName')?.touched
            "
            [attr.aria-describedby]="
              anagraficaForm.get('supplierName')?.invalid &&
              anagraficaForm.get('supplierName')?.touched
                ? 'supplier-name-error'
                : null
            "
          />
          @if (isEditModeAnagrafica()) {
            <app-validation-error
              [control]="anagraficaForm.get('supplierName')"
              errorId="supplier-name-error"
              mode="strict"
            />
            <small class="block mt-1 text-600">Non inserire il tipo di società</small>
          }
        </div>

        <div class="item">
          <label for="supplier-type"
            >Tipo Società <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <p-select
            id="supplier-type"
            formControlName="supplierTypeId"
            [options]="supplierTypeOptions()"
            optionLabel="valueDescription"
            optionValue="valueKey"
            placeholder="Seleziona tipo società"
            aria-label="Tipo Società"
            styleClass="w-full"
            [attr.aria-required]="true"
            [attr.aria-invalid]="
              anagraficaForm.get('supplierTypeId')?.invalid &&
              anagraficaForm.get('supplierTypeId')?.touched
            "
          >
          </p-select>
          @if (
            anagraficaForm.get('supplierTypeId')?.invalid &&
            anagraficaForm.get('supplierTypeId')?.touched &&
            isEditModeAnagrafica()
          ) {
            <small class="p-error" role="alert">Campo obbligatorio</small>
          }
        </div>
        
        <div class="item">
          <label for="supplier-alt-name">Denominazione commerciale</label>
          <input
            id="supplier-alt-name"
            pInputText
            formControlName="alternativeName"
            aria-label="Denominazione commerciale"
          />
        </div>

        <div class="item">
          <label for="person-type"
            >Persona fisica / giuridica
            <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <p-select
            id="person-type"
            formControlName="personType"
            [options]="personTypeOptions()"
            optionLabel="valueDescription"
            optionValue="valueKey"
            placeholder="Seleziona tipo persona"
            aria-label="Persona fisica / giuridica"
            styleClass="w-full"
            [attr.aria-required]="true"
            [attr.aria-invalid]="
              anagraficaForm.get('personType')?.invalid && anagraficaForm.get('personType')?.touched
            "
          >
          </p-select>
          @if (
            anagraficaForm.get('personType')?.invalid &&
            anagraficaForm.get('personType')?.touched &&
            isEditModeAnagrafica()
          ) {
            <small class="p-error" role="alert">Campo obbligatorio</small>
          }
        </div>

        <div class="item">
          <label for="supplier-vat-country">Prefisso paese partita IVA <span class="text-red-500" aria-hidden="true">*</span></label>
          @if (isEditModeAnagrafica()) {
          <p-select
            inputId="supplier-vat-country"
            formControlName="vatCountry"
            [options]="vatCountryOptions()"
            optionLabel="valueDescription"
            optionValue="valueKey"
            [filter]="true"
            filterBy="valueDescription,valueKey"
            placeholder="Seleziona paese IVA"
            ariaLabel="Prefisso paese partita IVA"
            styleClass="w-full"
            [attr.aria-required]="true"
            [attr.aria-invalid]="anagraficaForm.get('vatCountry')?.invalid && anagraficaForm.get('vatCountry')?.touched"
            [attr.aria-describedby]="supplier().vatCountry ? 'supplier-vat-country-error' : 'supplier-vat-country-legacy supplier-vat-country-error'"
          >
            <ng-template #selectedItem let-country>
              {{ country.valueKey }} - {{ country.valueDescription }}
            </ng-template>
            <ng-template #item let-country>
              {{ country.valueKey }} - {{ country.valueDescription }}
            </ng-template>
          </p-select>
          @if (!supplier().vatCountry) {
            <small id="supplier-vat-country-legacy">
              Fornitore registrato senza paese della partita IVA: seleziona il paese e inserisci la partita IVA senza prefisso.
            </small>
          }
          <app-validation-error [control]="anagraficaForm.get('vatCountry')" errorId="supplier-vat-country-error" />
          } @else {
            <input
              id="supplier-vat-country"
              pInputText
              aria-label="Prefisso paese partita IVA"
              [value]="supplier().vatCountry ?? ''"
              placeholder="Non specificato"
              disabled
            />
          }
        </div>

        <div class="item">
          <label for="supplier-vat"
            >Partita IVA
            @if (isVatNumberRequired()) {
              <span class="text-red-500" aria-hidden="true">*</span>
            }
          </label>
          @if (isEditModeAnagrafica()) {
          <input
            id="supplier-vat"
            pInputText
            formControlName="vatNumber"
            aria-label="Partita IVA"
            [placeholder]="vatNumberHint"
            [maxlength]="vatNumberMaxLength"
            aria-describedby="supplier-vat-hint supplier-vat-error"
            [attr.aria-invalid]="
              anagraficaForm.get('vatNumber')?.invalid && anagraficaForm.get('vatNumber')?.touched
            "
          />
          <small id="supplier-vat-hint">Senza prefisso paese. {{ vatNumberHint }}.</small>
          } @else {
            <input
              id="supplier-vat"
              pInputText
              aria-label="Partita IVA"
              [value]="supplier().vatNumber ? (supplier().vatCountry ?? '') + supplier().vatNumber : ''"
              disabled
            />
          }
          @if (
            anagraficaForm.get('vatNumber')?.invalid &&
            anagraficaForm.get('vatNumber')?.touched &&
            isEditModeAnagrafica()
          ) {
            @if (anagraficaForm.get('vatNumber')?.errors?.['required']) {
              <small class="p-error" role="alert">Campo obbligatorio per Persona Giuridica</small>
            }
            @if (anagraficaForm.get('vatNumber')?.errors?.['invalidVatNumber']) {
              <small id="supplier-vat-error" class="p-error" role="alert">Partita IVA non valida. {{ vatNumberHint }}, senza prefisso paese.</small>
            }
          }
        </div>
        <div class="item">
          <label for="supplier-fiscal"
            >Codice Fiscale <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <input
            id="supplier-fiscal"
            pInputText
            formControlName="fiscalCode"
            aria-label="Codice Fiscale"
            [attr.aria-required]="true"
            [attr.aria-invalid]="
              anagraficaForm.get('fiscalCode')?.invalid && anagraficaForm.get('fiscalCode')?.touched
            "
          />
          @if (
            anagraficaForm.get('fiscalCode')?.invalid &&
            anagraficaForm.get('fiscalCode')?.touched &&
            isEditModeAnagrafica()
          ) {
            @if (anagraficaForm.get('fiscalCode')?.errors?.['required']) {
              <small class="p-error" role="alert">Campo obbligatorio</small>
            }
            @if (anagraficaForm.get('fiscalCode')?.errors?.['invalidTaxCode']) {
              <small class="p-error" role="alert">Codice fiscale non valido</small>
            }
          }
        </div>

        <div class="item">
          <label for="supplier-primary-email">Email ordinaria</label>
          <input
            id="supplier-primary-email"
            pInputText
            type="email"
            formControlName="primaryEmail"
            [attr.aria-invalid]="
              anagraficaForm.get('primaryEmail')?.invalid &&
              anagraficaForm.get('primaryEmail')?.touched
            "
            aria-label="Email ordinaria"
          />
        </div>
        <div class="item">
          <label for="supplier-email">Email PEC</label>
          <input
            id="supplier-email"
            pInputText
            type="email"
            formControlName="certifiedEmail"
            [attr.aria-invalid]="
              anagraficaForm.get('certifiedEmail')?.invalid &&
              anagraficaForm.get('certifiedEmail')?.touched
            "
            [attr.aria-describedby]="
              anagraficaForm.get('certifiedEmail')?.invalid &&
              anagraficaForm.get('certifiedEmail')?.touched
                ? 'supplier-email-error'
                : null
            "
            aria-label="Email PEC"
          />
          @if (
            anagraficaForm.get('certifiedEmail')?.invalid &&
            anagraficaForm.get('certifiedEmail')?.touched &&
            isEditModeAnagrafica()
          ) {
            @if (
              anagraficaForm.get('certifiedEmail')?.errors?.['email'] ||
              anagraficaForm.get('certifiedEmail')?.errors?.['invalidPecEmail']
            ) {
              <small id="supplier-email-error" class="p-error" role="alert"
                >Formato email non valido</small
              >
            }
          }
        </div>

        <div class="item">
          <label for="supplier-contact">Nome Referente</label>
          <input
            id="supplier-contact"
            pInputText
            formControlName="contactPerson"
            aria-label="Nome Referente"
          />
        </div>
        <div class="item">
          <label for="supplier-phone">Telefono</label>
          <input
            id="supplier-phone"
            pInputText
            formControlName="telephoneNumber"
            [attr.aria-invalid]="
              anagraficaForm.get('telephoneNumber')?.invalid &&
              anagraficaForm.get('telephoneNumber')?.touched
            "
            [attr.aria-describedby]="
              anagraficaForm.get('telephoneNumber')?.invalid &&
              anagraficaForm.get('telephoneNumber')?.touched
                ? 'supplier-phone-error'
                : null
            "
            aria-label="Telefono"
          />
          @if (
            anagraficaForm.get('telephoneNumber')?.invalid &&
            anagraficaForm.get('telephoneNumber')?.touched &&
            isEditModeAnagrafica()
          ) {
            @if (anagraficaForm.get('telephoneNumber')?.errors?.['invalidPhoneNumber']) {
              <small id="supplier-phone-error" class="p-error" role="alert"
                >Numero di telefono non valido. Formato: +39 seguito da 8-11 cifre o 8-11
                cifre</small
              >
            }
          }
        </div>
        <div class="item">
          <label for="supplier-mobile">Mobile</label>
          <input
            id="supplier-mobile"
            pInputText
            formControlName="mobileNumber"
            [attr.aria-invalid]="
              anagraficaForm.get('mobileNumber')?.invalid &&
              anagraficaForm.get('mobileNumber')?.touched
            "
            aria-label="Mobile"
          />
          @if (
            anagraficaForm.get('mobileNumber')?.invalid &&
            anagraficaForm.get('mobileNumber')?.touched &&
            isEditModeAnagrafica()
          ) {
            @if (anagraficaForm.get('mobileNumber')?.errors?.['invalidMobileNumber']) {
              <small class="p-error" role="alert"
                >Numero di cellulare non valido. Formato: +39 seguito da 3 e 9 cifre</small
              >
            }
          }
        </div>

        <div class="item">
          <label for="supplier-buyer"
            >Buyer AXA <span class="text-red-500" aria-hidden="true">*</span></label
          >
          <input
            id="supplier-buyer"
            pInputText
            formControlName="axaBuyer"
            aria-label="Buyer AXA"
            [attr.aria-required]="true"
            [attr.aria-invalid]="
              anagraficaForm.get('axaBuyer')?.invalid && anagraficaForm.get('axaBuyer')?.touched
            "
          />
          @if (
            anagraficaForm.get('axaBuyer')?.invalid &&
            anagraficaForm.get('axaBuyer')?.touched &&
            isEditModeAnagrafica()
          ) {
            <small class="p-error" role="alert">Campo obbligatorio</small>
          }
        </div>
      </div>

      <!-- Separatore per sezione indirizzo -->
      <hr class="my-4 border-200" />

      <!-- Sezione Indirizzo -->
      <h3 id="indirizzo-heading" class="text-lg font-semibold mb-3" style="color: #00125b">
        <i class="pi pi-map-marker mr-2" aria-hidden="true"></i>
        Indirizzo Sede Legale
      </h3>

      <div class="form-grid" [formGroup]="anagraficaForm">
        <div class="item">
          <label for="address-typology">Toponimo</label>
          <p-select
            inputId="address-typology"
            [options]="addressTypologyOptions()"
            formControlName="addressTypology"
            optionLabel="valueDescription"
            optionValue="valueKey"
            placeholder="Seleziona toponimo"
            [filter]="true"
            filterPlaceholder="Cerca toponimo"
            aria-label="Toponimo indirizzo"
          >
          </p-select>
        </div>
        <div class="item">
          <label for="address-name">Indirizzo</label>
          <input
            id="address-name"
            pInputText
            formControlName="address"
            placeholder="Via/Piazza e nome"
            aria-label="Indirizzo - via o piazza"
          />
        </div>

        <div class="item">
          <label for="address-number">Civico</label>
          <input
            id="address-number"
            pInputText
            formControlName="addressNumber"
            placeholder="Numero civico"
            aria-label="Numero civico"
          />
        </div>
        <div class="item">
          <label for="zip-code">CAP</label>
          <input
            id="zip-code"
            pInputText
            formControlName="zipCode"
            placeholder="Codice postale"
            aria-label="CAP - Codice postale"
          />
        </div>

        <div class="item">
          <label for="country">Paese</label>
          <p-select
            inputId="country"
            [options]="countryOptions()"
            formControlName="country"
            optionLabel="name"
            optionValue="code"
            placeholder="Seleziona paese"
            [filter]="true"
            filterPlaceholder="Cerca paese"
            showClear="true"
            aria-label="Paese"
          >
          </p-select>
        </div>
        <div class="item">
          <label for="region">Regione</label>
          <p-select
            inputId="region"
            [options]="regionOptions()"
            formControlName="region"
            optionLabel="name"
            optionValue="code"
            placeholder="Seleziona regione"
            [filter]="true"
            filterPlaceholder="Cerca regione"
            showClear="true"
            aria-label="Regione"
          >
          </p-select>
        </div>

        <div class="item">
          <label for="province">Provincia</label>
          <p-select
            inputId="province"
            [options]="provinceOptions()"
            formControlName="province"
            optionLabel="name"
            optionValue="code"
            placeholder="Seleziona provincia"
            [filter]="true"
            filterPlaceholder="Cerca provincia"
            showClear="true"
            aria-label="Provincia"
          >
          </p-select>
        </div>
        <div class="item">
          <label for="municipality">Comune</label>
          <p-select
            inputId="municipality"
            [options]="municipalityOptions()"
            formControlName="municipality"
            optionLabel="name"
            optionValue="code"
            placeholder="Seleziona comune"
            [filter]="true"
            filterPlaceholder="Cerca comune"
            showClear="true"
            aria-label="Comune"
          >
          </p-select>
        </div>
      </div>

      <!-- Button always visible in the section footer -->
      <div class="flex flex-wrap justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
        @if (!isEditModeAnagrafica()) {
          <p-button
            label="Modifica"
            [outlined]="true"
            size="small"
            (click)="toggleEditAnagrafica()" [attr.aria-label]="'Modifica anagrafica fornitore'"
            title="Modifica anagrafica fornitore"
          ></p-button>
        } @else {
          <p-button
            label="Annulla"
            [outlined]="true"
            size="small"
            (click)="cancelEditAnagrafica()" [attr.aria-label]="'Annulla modifiche anagrafica'"
            title="Annulla modifiche anagrafica"
          ></p-button>
          <p-button
            label="Salva"
            icon="pi pi-check"
            size="small"
            (click)="saveAnagrafica()" [attr.aria-label]="'Salva modifiche anagrafica fornitore'"
            title="Salva modifiche anagrafica fornitore"
          ></p-button>
        }
      </div>
    </section>

    <!-- ================= SECTION 2: DETTAGLI ================= -->
    <section
      appCollapsibleSection
      class="surface-0 border-round p-5 mb-4 shadow-1"
      role="region"
      aria-labelledby="dettagli-heading"
    >
      <div class="flex align-items-center gap-3 mb-4 pb-3 border-bottom-1 border-200">
        <i class="pi pi-list text-2xl" style="color: #00125b" aria-hidden="true"></i>
        <h2 id="dettagli-heading" class="text-xl font-semibold m-0">
          Dettagli Anagrafica Fornitore
        </h2>
        <app-section-collapse-toggle sectionName="Dettagli Anagrafica Fornitore"></app-section-collapse-toggle>
      </div>

      <div class="form-grid" [formGroup]="detailsForm">
        <div class="item">
          <label for="code-albo">Codice Albo SOL</label>
          <input
            id="code-albo"
            pInputText
            formControlName="codeAlboSOL"
            aria-label="Codice Albo SOL"
          />
        </div>
        <div class="item">
          <label for="code-coupa">Supplier Coupa</label>
          <input
            id="code-coupa"
            pInputText
            formControlName="codeSupplierCoupa"
            aria-label="Codice Supplier Coupa"
          />
        </div>
        <div class="item">
          <label for="coupa-author">Autore inserimento Coupa</label>
          <input
            id="coupa-author"
            pInputText
            formControlName="coupaAuthor"
            aria-label="Autore inserimento Coupa - campo opzionale"
          />
        </div>
        <div class="item">
          <label for="code-bravo">Supplier Bravo Solution</label>
          <input
            id="code-bravo"
            pInputText
            formControlName="codeSupplierBravoSolution"
            aria-label="Codice Supplier Bravo Solution"
          />
        </div>
      </div>

      <!-- Button always visible in the section footer -->
      <div class="flex flex-wrap justify-content-end gap-2 mt-4 pt-3 border-top-1 border-200">
        @if (!isEditModeDetails()) {
          <p-button
            label="Modifica"
            [outlined]="true"
            size="small"
            (onClick)="toggleEditDetails()" [attr.aria-label]="'Modifica dettagli fornitore'"
            title="Modifica dettagli fornitore"
          ></p-button>
        } @else {
          <p-button
            label="Annulla"
            [outlined]="true"
            size="small"
            (click)="cancelEditDetails()" [attr.aria-label]="'Annulla modifiche dettagli'"
            title="Annulla modifiche dettagli"
          ></p-button>
          <p-button
            label="Salva"
            icon="pi pi-check"
            size="small"
            (onClick)="saveDetails()" [attr.aria-label]="'Salva modifiche dettagli fornitore'"
            title="Salva modifiche dettagli fornitore"
          ></p-button>
        }
      </div>
    </section>

    <!-- ================= SECTION 3: CONTRATTI ================= -->
    <app-contracts-registry
      [supplierId]="supplierId()"
      [parentBreadcrumb]="breadcrumbItems()"
    ></app-contracts-registry>
  } @else {
    <!-- Loading state -->
    <div class="p-4 text-center" role="status" aria-live="polite">
      <p-progressSpinner [attr.aria-label]="'Caricamento in corso'"></p-progressSpinner>
      <p class="mt-3">Caricamento dettagli fornitore...</p>
    </div>
  }
</div>
